import {Component, OnInit, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'payloc-right-nav',
  templateUrl: './payloc-right-nav.component.html',
  styleUrls: ['./payloc-right-nav.component.css']
})
export class PaylocRightNavComponent implements OnInit {

  @HostBinding('class') classes = 'margin-content';

  @Input('readonly')
  public readonly;

  constructor() { }

  ngOnInit() {
  }

}
